import ExcelJS from "exceljs";

const formatDateOnly = (dateStr) => {
  if (!dateStr) return "";
  let d = new Date(dateStr.replace("IST", "+0530"));
  if (isNaN(d)) return dateStr;
  const pad = n => (n < 10 ? "0" + n : n);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const generateInvoiceExcel = async (dtoList) => {
  const workbook = new ExcelJS.Workbook();

  // Generate ONE sheet only
  const today = formatDateOnly(new Date().toString()).replace(/\//g, "-");
  const sheet = workbook.addWorksheet(`Pharmacy Prescription Report_${today}`);

  const first = dtoList[0];
  const firm = first.firmInfo;

  // =======================================================
  // TOP HOSPITAL HEADER (only once)
  // =======================================================
  sheet.addRow([firm.FIRM_NAME]).font = { size: 16, bold: true };
  sheet.addRow([`${firm.FIRM_ADDRESS}, ${firm.  FIRM_CITY} - ${firm.FIRM_PINCODE}`]);
  sheet.addRow([`Phone: ${firm.FIRM_PHONE}`]);
  sheet.addRow([]);
  sheet.addRow(["PHARMACY PRESCRIPTION REPORT"]).font = { bold: true, size: 14 };
  sheet.addRow([]);

  // =======================================================
  // LOOP THROUGH EACH INVOICE
  // =======================================================
  dtoList.forEach((dto, index) => {
    const cust = dto.customerDetail;
    const items = dto.billingItem;

    // ---------------- Patient Block ----------------
    sheet.addRow([
      `Name: ${cust.patientName}`,
      `Reg No.: ${cust.regNumber}`
    ]);

    sheet.addRow([
      `Date: ${formatDateOnly(cust.doa)}`,
      `Bill No.: ${cust.billNumber}`
    ]);

    sheet.addRow([]); // spacing

    // ---------------- Table Header ----------------
    const headerRow = sheet.addRow(["Product Name", "Qty."]);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF999999" }
    };

    // ---------------- Billing Items ----------------
    items.forEach((item) => {
      sheet.addRow([item.serviceName, item.units]);
    });

    // Leave 3–4 blank rows before next invoice
    if (index !== dtoList.length - 1) {
      sheet.addRow([]);
      sheet.addRow([]);
      sheet.addRow([]);
      sheet.addRow([]);
    }
  });

  // ---------------- Download Buffer ----------------
  const buffer = await workbook.xlsx.writeBuffer();
  return buffer;
};






// export const generateCollectionDetailsExcel = async (rows) => {
//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Collection Details");

//   // ---------------- Normalize Payment Mode ----------------
//   const normalizePaymentMode = (mode) => {
//     if (!mode) return "";

//     const m = mode.toString().trim().toLowerCase();

//     if (["cash", "ca", "cb"].includes(m)) return "Cash";
//     if (["magcard", "mgcard", "card", "cc"].includes(m)) return "Card";
//     if (["paytm", "pt", "ip"].includes(m)) return "Paytm";
//     if (["cheque", "ch", "dd"].includes(m)) return "Cheque";
//     if (["wallet", "mo"].includes(m)) return "Wallet";
//     if (["ticket", "vo"].includes(m)) return "Ticket";

//     return m;
//   };

//   // ---------------- Title ----------------
//   const titleRow = sheet.addRow(["COLLECTION DETAILS REPORT"]);
//   titleRow.font = { size: 16, bold: true };

//   sheet.addRow([`Generated On: ${new Date().toLocaleString("en-IN")}`]);
//   sheet.addRow([]);

//   // ---------------- Header ----------------
//   const headerRow = sheet.addRow([
//     "Receipt No",
//     "Patient ID",
//     // "IP / OP Number",
//     "Patient Name",
//     "Location",
//     "Payment Mode",
//     "Collected By",
//     "Amount",
//     "Payment Date",
//     "Voucher / Bill No",
//     "Type",
//   ]);

//   headerRow.font = { bold: true };

//   headerRow.eachCell((cell) => {
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FFE0E0E0" },
//     };
//     cell.alignment = { horizontal: "center" };
//   });

//   // ---------------- Data Rows ----------------
//   const ipModeTotals = {};
//   const opModeTotals = {};
//   let ipGrandTotal = 0;
//   let opGrandTotal = 0;
//   let finalGrandTotal = 0;

//   rows.forEach((r) => {
//     const normalizedMode = normalizePaymentMode(r.paymentMode);
//     const amount = r.paymentAmount || 0;

//     sheet.addRow([
//       r.billNumber || "",
//       r.patientID || "",
//       // r.ipopnumber || "",
//       r.customerName?.trim() || "",
//       r.location || "",
//       normalizedMode,
//       r.user || "",
//       amount,
//       new Date(r.paymentDate).toLocaleDateString("en-IN"),
//       r.voucherNumber || "",
//       r.type,
//     ]);

//     // Calculate totals
//     // Separate IP and OP based on type
//   const location = r.location?.toLowerCase() || "";

//   const isIP = location.includes("in-patient");
//   const isOP = location.includes("out-patient");


//   if (isIP) {
//     if (!ipModeTotals[normalizedMode]) {
//       ipModeTotals[normalizedMode] = 0;
//     }
//     ipModeTotals[normalizedMode] += amount;
//     ipGrandTotal += amount;
//   }

//   if (isOP) {
//     if (!opModeTotals[normalizedMode]) {
//       opModeTotals[normalizedMode] = 0;
//     }
//     opModeTotals[normalizedMode] += amount;
//     opGrandTotal += amount;
//   }

//   finalGrandTotal += amount;
//   });

//   // ---------------- Column Widths ----------------
//   sheet.columns = [
//     { width: 18 }, // Receipt
//     { width: 14 }, // Patient ID
//     { width: 16 }, // IP/OP
//     { width: 26 }, // Name
//     { width: 18 }, // Location
//     { width: 15 }, // Mode
//     { width: 18 }, // Collected by
//     { width: 14 }, // Amount
//     { width: 16 }, // Date
//     { width: 22 }, // Voucher
//   ];
// sheet.addRow([]);

// // ================= IP SUMMARY =================
// const ipTitle = sheet.addRow(["", "", "", "", "", "", "IP COLLECTION TOTALS"]);
// ipTitle.font = { bold: true };

// Object.entries(ipModeTotals).forEach(([mode, total]) => {
//   const row = sheet.addRow(["", "", "", "", "", mode, total]);
//   row.font = { bold: true };
// });

// const ipTotalRow = sheet.addRow(["", "", "", "", "", "IP TOTAL", ipGrandTotal]);
// ipTotalRow.font = { bold: true };

// sheet.addRow([]);

// // ================= OP SUMMARY =================
// const opTitle = sheet.addRow(["", "", "", "", "", "", "OP COLLECTION TOTALS"]);
// opTitle.font = { bold: true };

// Object.entries(opModeTotals).forEach(([mode, total]) => {
//   const row = sheet.addRow(["", "", "", "", "", mode, total]);
//   row.font = { bold: true };
// });

// const opTotalRow = sheet.addRow(["", "", "", "", "", "OP TOTAL", opGrandTotal]);
// opTotalRow.font = { bold: true };

// sheet.addRow([]);

// // ================= FINAL GRAND TOTAL =================
// const finalTotalRow = sheet.addRow(["", "", "", "", "", "GRAND TOTAL", finalGrandTotal]);
// finalTotalRow.font = { bold: true };

//   return workbook.xlsx.writeBuffer();
// };


export const generateCollectionDetailsExcel = async (apiResponse) => {
  const { customerPaymentInfo: rows = [], summary = [] } = apiResponse;

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Collection Details");

  const normalizePaymentMode = (mode) => {
    if (!mode) return "";

    const m = mode.toString().trim().toLowerCase();

    if (["cash", "CASH", "ca", "cb"].includes(m)) return "Cash";
    if (["magcard", "mgcard", "card", "CARD", "cc"].includes(m)) return "Card";
    if (["paytm", "PAYTM", "PT", "pt", "ip"].includes(m)) return "UPI";
    if (["cheque", "ch", "dd"].includes(m)) return "Cheque";
    if (["wallet", "mo"].includes(m)) return "Wallet";
    return m;
  };

  // ---------------- Title ----------------
  const titleRow = sheet.addRow(["COLLECTION DETAILS REPORT"]);
  titleRow.font = { size: 16, bold: true };

  sheet.addRow([`Generated On: ${new Date().toLocaleString("en-IN")}`]);
  sheet.addRow([]);

  // ---------------- Header ----------------
  const headerRow = sheet.addRow([
    "Receipt No",
    "Patient ID",
    "Patient Name",
    "Location",
    "Payment Mode",
    "Collected By",
    "Amount",
    "Payment Date",
    "Voucher / Bill No",
    "Type",
  ]);

  headerRow.font = { bold: true };

  // ---------------- Data Rows ----------------
  rows.forEach((r) => {
    sheet.addRow([
      r.billNumber || "",
      r.patientID || "",
      r.customerName?.trim() || "",
      r.location || "",
      normalizePaymentMode(r.paymentMode),
      r.user || "",
      r.paymentAmount || 0,
      r.paymentDate
        ? new Date(r.paymentDate).toLocaleDateString("en-IN")
        : "",
      r.voucherNumber || "",
      r.type || "",
    ]);
  });

  sheet.addRow([]);
  sheet.addRow([]);

  // ==================================================
  // ================= SUMMARY SECTION =================
  // ==================================================

  const grouped = {};
  let grandTotal = 0;

  summary.forEach((s) => {
    const location = s.location;
    const mode = s.paymentMode;
    const type = s.type;
    const amount = s.totalAmount || 0;

    if (!grouped[location]) {
      grouped[location] = {};
    }

    if (!grouped[location][type]) {
      grouped[location][type] = {};
    }

    grouped[location][type][mode] = amount;

    grandTotal += amount;
  });

  sheet.addRow(["SUMMARY"]);
  sheet.lastRow.font = { bold: true };

  Object.keys(grouped).forEach((location) => {
    sheet.addRow([]);
    const locRow = sheet.addRow([location]);
    locRow.font = { bold: true };

    Object.keys(grouped[location]).forEach((type) => {
      const typeRow = sheet.addRow(["", type]);
      typeRow.font = { bold: true };

      Object.entries(grouped[location][type]).forEach(
        ([mode, total]) => {
          mode = normalizePaymentMode(mode);
          sheet.addRow(["", "", mode, total]);
        }
      );
    });
  });

  sheet.addRow([]);
  const grandRow = sheet.addRow(["", "", "GRAND TOTAL", grandTotal]);
  grandRow.font = { bold: true };

  return workbook.xlsx.writeBuffer();
};



export const generateServiceRevenueExcel = async (rows) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Service Revenue");

  // -------- Title --------
  sheet.addRow(["SERVICE REVENUE REPORT"]).font = {
    size: 16,
    bold: true,
  };

  sheet.addRow([`Generated On: ${new Date().toLocaleString("en-IN")}`]);
  sheet.addRow([]);

  // -------- Header --------
  const headerRow = sheet.addRow([
    "Service Name",
    "Category",
    "Total Quantity",
    "Total Amount",
  ]);

  headerRow.font = { bold: true };

  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = { horizontal: "center" };
  });

  // -------- Rows --------
  rows.forEach((r) => {
    sheet.addRow([
      r.serviceName,
      r.category || "",
      r.totalQuantity,
      r.totalAmt,
    ]);
  });

  // -------- Column Widths --------
  sheet.columns = [
    { width: 35 },
    { width: 25 },
    { width: 18 },
    { width: 18 },
  ];

  return workbook.xlsx.writeBuffer();
};



// export const generateBillSummaryExcel = async (rows) => {
//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Bill Summary");

//   // -------- Title --------
//   sheet.addRow(["BILL SUMMARY REPORT"]).font = {
//     size: 16,
//     bold: true,
//   };

//   sheet.addRow([`Generated On: ${new Date().toLocaleString("en-IN")}`]);
//   sheet.addRow([]);

//   // -------- Header --------
//   const headerRow = sheet.addRow([
//     "Department",
//     "Reg No",
//     "Patient Name",
//     "Bill No",
//     "Bill Date",
//     "Visit Type",
//     "Gross Amount",
//     "Discount Amount",
//     "Net Amount",
//     "Round Off",
//     "Billed By",
//   ]);

//   headerRow.font = { bold: true };

//   headerRow.eachCell((cell) => {
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FFE0E0E0" },
//     };
//     cell.border = {
//       top: { style: "thin" },
//       left: { style: "thin" },
//       bottom: { style: "thin" },
//       right: { style: "thin" },
//     };
//     cell.alignment = {
//       horizontal: "center",
//       vertical: "middle",
//     };
//   });

//   // -------- Rows --------
//   rows.forEach((r) => {
//     const row = sheet.addRow([
//       r.department,
//       r.regNo,
//       r.patientName,
//       r.billNo,
//       r.billDate,
//       r.visitType,
//       r.grossAmount,
//       r.discountAmount,
//       r.netAmount,
//       r.roundOff,
//       r.billedBy,
//     ]);

//     // Right-align numeric columns
//     [7, 8, 9, 10].forEach((colIndex) => {
//       row.getCell(colIndex).alignment = { horizontal: "right" };
//     });
//   });

//   // -------- Column Widths --------
//   sheet.columns = [
//     { width: 22 }, // Department
//     { width: 12 }, // Reg No
//     { width: 30 }, // Patient Name
//     { width: 18 }, // Bill No
//     { width: 14 }, // Bill Date
//     { width: 14 }, // Visit Type
//     { width: 16 }, // Gross
//     { width: 18 }, // Discount
//     { width: 16 }, // Net
//     { width: 14 }, // Round Off
//     { width: 20 }, // Billed By
//   ];

//   return workbook.xlsx.writeBuffer();
// };



export const generateBillingBundleExcel = async ({
  billRows,
  advanceRows,
  refundRows,
}) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Billing Summary");

  /* ============================
     Helper functions
  ============================ */
    const addGap = (count = 3) => {
      for (let i = 0; i < count; i++) sheet.addRow([]);
    };

    const setColumnWidths = (widths) => {
      widths.forEach((w, i) => {
        sheet.getColumn(i + 1).width = w;
      });
    };

    const addHeader = (headers) => {
      const row = sheet.addRow(headers);
      row.font = { bold: true };

      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE0E0E0" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    };

  const addTitle = (title) => {
    const r = sheet.addRow([title]);
    r.font = { size: 16, bold: true };
    sheet.addRow([`Generated On: ${new Date().toLocaleString("en-IN")}`]);
    sheet.addRow([]);
  };

  // const addHeader = (headers) => {
  //   const row = sheet.addRow(headers);
  //   row.font = { bold: true };
  //   row.eachCell((cell) => {
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFE0E0E0" },
  //     };
  //     cell.border = {
  //       top: { style: "thin" },
  //       left: { style: "thin" },
  //       bottom: { style: "thin" },
  //       right: { style: "thin" },
  //     };
  //     cell.alignment = { horizontal: "center" };
  //   });
  // };

  // const addGap = () => {
  //   sheet.addRow([]);
  //   sheet.addRow([]);
  //   sheet.addRow([]);
  // };

/* ============================
   1️⃣ BILL SUMMARY (UPDATED)
============================ */

if (billRows.length) {
  addTitle("BILL BALANCE REPORT");
  addGap();

  // 🔹 Column widths (clean & readable)
  setColumnWidths([
    22, // Department
    12, // Reg No
    30, // Patient Name
    18, // Bill No
    14, // Visit Type
    16, // Gross
    16, // Total
    16, // Received
    16, // Balance
  ]);

  addHeader([
    "Department",
    "Reg No",
    "Patient Name",
    "Bill No",
    "Visit Type",
    "Gross Amount",
    "Total Amount",
    "Received Amount",
    "Balance Amount",
  ]);

  let totalGross = 0;
  let totalTotal = 0;
  let totalReceived = 0;
  let totalBalance = 0;

  billRows.forEach((r) => {
    totalGross += r.gross || 0;
    totalTotal += r.total || 0;
    totalReceived += r.received || 0;
    totalBalance += r.balance || 0;

    sheet.addRow([
      r.department,
      r.regNo,
      r.patientName,
      r.billNo,
      r.visitType,
      r.gross,
      r.total,
      r.received,
      r.balance,
    ]);
  });

  // 🔹 TOTAL ROW
  const totalRow = sheet.addRow([
    "TOTAL",
    "",
    "",
    "",
    "",
    totalGross,
    totalTotal,
    totalReceived,
    totalBalance,
  ]);

  totalRow.font = { bold: true };
  totalRow.eachCell((cell) => {
    cell.border = {
      top: { style: "double" },
    };
  });

  addGap(4);
}


  /* ============================
     2️⃣ ADVANCE REPORT
  ============================ */

  if (advanceRows.length) {
    addTitle("ADVANCE RECEIVED REPORT");
    addGap();

    // 🔹 SET WIDTHS FOR ADVANCE
    setColumnWidths([
      22, // Department
      14, // Customer ID
      20, // Receipt No
      16, // Payment Date
      14, // Payment Mode
      16, // Amount
      16, // Used
      18, // Remaining
      30, // Patient Name
      20, // Billed By
    ]);
      
    addHeader([
      "Department",
      "Customer ID",
      "Receipt No",
      "Payment Date",
      "Payment Mode",
      "Amount",
      "Used Amount",
      "Remaining Amount",
      "Patient Name",
      "Billed By",
    ]);

    advanceRows.forEach((r) => {
      sheet.addRow([
        r.department,
        r.customerId,
        r.receiptNo || "",
        r.paymentDate,
        r.paymentMode,
        r.amount,
        r.usedAmount,
        r.remainingAmount,
        r.patientName,
        r.billedBy,
      ]);
    });

    addGap(4);
  }

  /* ============================
     3️⃣ REFUND REPORT
  ============================ */

  if (refundRows.length) {
    addTitle("ADVANCE REFUND REPORT");
    addGap(2);

    setColumnWidths([
      22, // Department
      14, // Customer ID
      20, // Receipt No
      16, // Refund Date
      14, // Payment Mode
      18, // Refund Amount
      30, // Patient Name
      20, // Billed By
    ]);

    addHeader([
      "Department",
      "Customer ID",
      "Receipt No",
      "Refund Date",
      "Payment Mode",
      "Refund Amount",
      "Patient Name",
      "Billed By",
    ]);

    refundRows.forEach((r) => {
      sheet.addRow([
        r.department,
        r.customerId,
        r.receiptNo,
        r.refundDate,
        r.paymentMode,
        r.refundAmount,
        r.patientName,
        r.billedBy,
      ]);
    });
  }

  return workbook.xlsx.writeBuffer();
};



export const generateBillRevenueExcel = async (
  rows,
  { fromDate, toDate, department = "ALL", type = "ALL" }
) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Bill Revenue");

  /* ---------------- Title ---------------- */
  sheet.addRow(["BILL REVENUE REPORT"]).font = {
    size: 16,
    bold: true,
  };

  sheet.addRow([
    `Bills ${fromDate} To ${toDate}, Dept:${department}, Type:${type}`,
  ]);

  sheet.addRow([]);

  /* ---------------- Header ---------------- */
  const headerRow = sheet.addRow([
    "Register No",
    "Patient Name",
    "Bill No",
    "Date",
    "Gross",
    "Net",
    "Discount",
    "Roff",
    "Billed By",
  ]);

  headerRow.font = { bold: true };

  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = { horizontal: "center" };
  });

  /* ---------------- Group by Department ---------------- */
  const grouped = {};
  rows.forEach((r) => {
    if (!grouped[r.department]) grouped[r.department] = [];
    grouped[r.department].push(r);
  });

  let grandGross = 0;
  let grandNet = 0;
  let grandDiscount = 0;

  /* ---------------- Rows ---------------- */
  Object.keys(grouped).forEach((dept) => {
    // Department header
    const deptRow = sheet.addRow([dept]);
    deptRow.font = { bold: true };

    let deptGross = 0;
    let deptNet = 0;
    let deptDiscount = 0;

    grouped[dept].forEach((r) => {
      sheet.addRow([
        r.registerNo,
        (r.patientName || "").replace(" null", ""),
        r.billNo,
        new Date(r.billDate).toLocaleString("en-IN"),
        r.gross,
        r.net,
        r.discount,
        r.roff,
        r.billedBy?.trim(),
      ]);

      deptGross += r.gross || 0;
      deptNet += r.net || 0;
      deptDiscount += r.discount || 0;
    });

    // Department total
    const totalRow = sheet.addRow([
      `Total : ${dept}`,
      "",
      `No.: ${grouped[dept].length}`,
      "",
      deptGross,
      deptNet,
      deptDiscount,
      "",
      "",
    ]);

    totalRow.font = { bold: true };

    sheet.addRow([]);

    grandGross += deptGross;
    grandNet += deptNet;
    grandDiscount += deptDiscount;
  });

  /* ---------------- Grand Total ---------------- */
  const grandTotalRow = sheet.addRow([
    "GRAND TOTAL",
    "",
    "",
    "",
    grandGross,
    grandNet,
    grandDiscount,
    "",
    "",
  ]);
  grandTotalRow.font = { bold: true };

  /* ---------------- Column Widths ---------------- */
  sheet.columns = [
    { width: 14 }, // Register No
    { width: 28 }, // Patient Name
    { width: 18 }, // Bill No
    { width: 22 }, // Date
    { width: 14 }, // Gross
    { width: 14 }, // Net
    { width: 14 }, // Discount
    { width: 12 }, // Roff
    { width: 18 }, // Billed By
  ];

  return workbook.xlsx.writeBuffer();
};



export const generateDoctorServiceExcel = async (
  rows,
  { year = "ALL" }
) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Doctor Service Report");

  /* ---------------- Title ---------------- */
  sheet.addRow(["DOCTOR SERVICE REPORT"]).font = {
    size: 16,
    bold: true,
  };

  sheet.addRow([`Year : ${year}`]);
  sheet.addRow([]);

  /* ---------------- Header ---------------- */
  const headerRow = sheet.addRow([
    "Month",
    "Doctor Name",
    "Consultation Count",
    "Total Amount (₹)",
  ]);

  headerRow.font = { bold: true };

  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = { horizontal: "center" };
  });

  /* ---------------- Group by Month ---------------- */
  const groupedByMonth = {};

  rows.forEach((r) => {
    if (!groupedByMonth[r.monthNo]) groupedByMonth[r.monthNo] = [];
    groupedByMonth[r.monthNo].push(r);
  });

  let grandTotalAmount = 0;
  let grandTotalCount = 0;

  /* ---------------- Rows ---------------- */
  Object.keys(groupedByMonth)
    .sort((a, b) => a - b)
    .forEach((monthNo) => {
      const monthName = new Date(2000, monthNo - 1, 1).toLocaleString("en-IN", {
        month: "long",
      });

      // Month header
      const monthRow = sheet.addRow([monthName]);
      monthRow.font = { bold: true };

      let monthTotalAmount = 0;
      let monthTotalCount = 0;

      groupedByMonth[monthNo].forEach((r) => {
        sheet.addRow([
          "", // month shown as header
          r.doctorName,
          r.consultationCount,
          r.totalAmount,
        ]);

        monthTotalAmount += r.totalAmount || 0;
        monthTotalCount += r.consultationCount || 0;
      });

      // Month total
      const totalRow = sheet.addRow([
        `Total : ${monthName}`,
        "",
        monthTotalCount,
        monthTotalAmount,
      ]);
      totalRow.font = { bold: true };

      sheet.addRow([]);

      grandTotalAmount += monthTotalAmount;
      grandTotalCount += monthTotalCount;
    });

  /* ---------------- Grand Total ---------------- */
  const grandTotalRow = sheet.addRow([
    "GRAND TOTAL",
    "",
    grandTotalCount,
    grandTotalAmount,
  ]);
  grandTotalRow.font = { bold: true };

  /* ---------------- Column Widths ---------------- */
  sheet.columns = [
    { width: 18 }, // Month
    { width: 30 }, // Doctor Name
    { width: 22 }, // Consultation Count
    { width: 22 }, // Total Amount
  ];

  return workbook.xlsx.writeBuffer();
};



export const generatePatientJourneyExcel = async (rows) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Patient Visit Journey");

  sheet.addRow(["PATIENT VISIT JOURNEY REPORT"]).font = { size: 16, bold: true };
  sheet.addRow([`Generated On: ${new Date().toLocaleString("en-IN")}`]);
  sheet.addRow([]);

  // Updated header row with phone numbers
  const headerRow = sheet.addRow([
    "Patient ID",
    "Patient Name",
    "IP/OP Number",
    "Visit Date",
    "Follow Up Date",
    "Phone Number",
    "Alternate Phone Number"
  ]);
  
  headerRow.font = { bold: true };
  headerRow.eachCell((cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE0E0E0" } };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
    cell.alignment = { horizontal: "center" };
  });

  // Group by patientId
  let lastPatientId = null;
  rows.forEach((r) => {
    if (r.patientId !== lastPatientId) {
      lastPatientId = r.patientId;
    }

    const dataRow = sheet.addRow([
      r.patientId,
      r.patientName,
      r.ipOpNumber || "",
      r.visitDate ? new Date(r.visitDate).toLocaleDateString("en-IN") : "",
      r.followUpDate ? new Date(r.followUpDate).toLocaleDateString("en-IN") : "",
      r.phoneNumber || "",              
      r.alternatePhoneNumber || "",   
    ]);

    // Bold only Patient ID and Name
    dataRow.getCell(1).font = { bold: true };
    dataRow.getCell(2).font = { bold: true };
  });

  sheet.columns = [
    { width: 14 },  
    { width: 30 }, 
    { width: 18 },  
    { width: 20 },  
    { width: 20 },  
    { width: 18 },  
    { width: 25 },  
  ];

  return workbook.xlsx.writeBuffer();
};
